import { render } from "./NewCrawlLocation.vue?vue&type=template&id=b7df650c&scoped=true"
import script from "./NewCrawlLocation.vue?vue&type=script&lang=js"
export * from "./NewCrawlLocation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b7df650c"

export default script